import { useState, useEffect } from 'react';

/**
 * Returns whether the given media query matches (e.g. for mobile breakpoint).
 * @param {string} query - Media query string (e.g. '(max-width: 768px)')
 * @returns {boolean}
 */
export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const m = window.matchMedia(query);
    const handler = (e) => setMatches(e.matches);
    setMatches(m.matches);
    m.addEventListener('change', handler);
    return () => m.removeEventListener('change', handler);
  }, [query]);

  return matches;
}

/** Mobile breakpoint used for session header and layout (matches App.css). */
export const MOBILE_BREAKPOINT = '(max-width: 768px)';
